import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    slug: '20l-jar',
    name: 'Vijaya Varshi 20L Jar',
    brand: 'Vijaya Varshi',
    capacity: '20 Litres',
    price: 60,
    deposit: 150,
    img: '/products/jar-20l.png?v=2',
    tag: 'Best Seller',
    tagBg: '#FDE8E8',
    tagColor: '#C8171A',
    headerBg: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)',
    description: 'Our flagship 20L crystal-clear refillable jar. Perfect for families and offices. Most economical at just ₹3 per litre.',
    highlights: ['Refillable food-grade BPA-free jar', 'Most economical per litre', 'Same-day delivery available', 'Deposit fully refundable'],
  },
  {
    id: 2,
    slug: '1l-bottle',
    name: 'Vijaya Varshi 1L Bottle',
    brand: 'Vijaya Varshi',
    capacity: '1 Litre',
    price: 20,
    deposit: null,
    img: '/products/bottle-1l.png?v=2',
    tag: 'Popular',
    tagBg: '#dcfce7',
    tagColor: '#16a34a',
    headerBg: 'linear-gradient(160deg, #f0fdf4 0%, #dcfce7 100%)',
    description: 'Tall 1L sealed bottle with the Vijaya Varshi mountain-design label. Perfect for home, gym and office use. No deposit.',
    highlights: ['Tamper-evident hygienic seal', 'No deposit required', 'Dining table & office desk use', 'Available in bulk packs'],
  },
  {
    id: 3,
    slug: '500ml-bottle',
    name: 'Vijaya 500ml Bottle',
    brand: 'Vijaya',
    capacity: '500 ml',
    price: 10,
    deposit: null,
    img: '/products/bottle-500ml.png?v=2',
    tag: 'On-the-Go',
    tagBg: '#fef3c7',
    tagColor: '#b45309',
    headerBg: 'linear-gradient(160deg, #fffbeb 0%, #fef3c7 100%)',
    description: 'Compact 500ml bottle. Handy for school, travel and commuting. Lightweight and easy to carry in any bag.',
    highlights: ['Lightweight & portable', 'School & travel use', 'Bulk packs for offices', 'Sealed for freshness'],
  },
  {
    id: 4,
    slug: '250ml-bottle',
    name: 'Vijaya 250ml Bottle',
    brand: 'Vijaya',
    capacity: '250 ml',
    price: 6,
    deposit: null,
    img: '/products/bottle-250ml.png?v=2',
    tag: 'Pocket Friendly',
    tagBg: '#f1f5f9',
    tagColor: '#475569',
    headerBg: 'linear-gradient(160deg, #f8fafc 0%, #f1f5f9 100%)',
    description: 'Smallest Vijaya bottle. Perfect for events, functions and bulk gifting. Best value on bulk orders.',
    highlights: ['Best per-bottle price', 'Events & functions use', 'Bulk discounts available', 'Individual serving size'],
  },
];

const trustItems = [
  '7-Stage Purification',
  'Lab Tested Every Batch',
  'ISI &amp; FSSAI Certified',
  'Same-Day Delivery',
];

export default function ProductsPage() {
  const [hovered, setHovered] = useState(null);

  return (
    <div style={{ background: '#ffffff' }}>

      {/* Slim Page Hero */}
      <section style={{ background: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)', padding: '2rem 1.5rem', borderBottom: '1px solid #fecaca' }}>
        <div className="page-container">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.6rem', fontSize: '0.82rem' }}>
            <Link to="/" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</Link>
            <span style={{ color: '#cbd5e1' }}>/</span>
            <span style={{ color: '#C8171A', fontWeight: 600 }}>Products</span>
          </div>
          <h1 style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)', fontWeight: 800, color: '#0c1a2e', margin: 0, lineHeight: 1.2 }}>
            Our Water Products
          </h1>
        </div>
      </section>

      {/* Products Grid */}
      <section className="section" style={{ background: 'var(--brand-sky)' }}>
        <div className="page-container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 className="section-title">Choose Your Product</h2>
            <p className="section-subtitle">All products use the same high-quality purified water &#8212; just different sizes for different needs.</p>
          </div>
          <div className="grid grid-4" style={{ gap: '1.5rem' }}>
            {products.map(p => (
              <div
                key={p.id}
                className="pub-card"
                style={{
                  overflow: 'hidden',
                  transform: hovered === p.id ? 'translateY(-5px)' : 'none',
                  boxShadow: hovered === p.id ? '0 16px 36px rgba(29,78,216,0.18)' : undefined,
                  transition: 'transform 0.25s, box-shadow 0.25s',
                }}
                onMouseEnter={() => setHovered(p.id)}
                onMouseLeave={() => setHovered(null)}
              >
                {/* Header */}
                <div style={{ background: p.headerBg, padding: '1.5rem 1rem 1rem', textAlign: 'center', position: 'relative', borderBottom: '1px solid var(--border-light)', height: 270, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', background: p.tagBg, color: p.tagColor, borderRadius: '9999px', padding: '0.2rem 0.65rem', fontSize: '0.7rem', fontWeight: 700, zIndex: 1 }}>
                    {p.tag}
                  </span>
                  <img
                    src={p.img}
                    alt={p.name}
                    onError={e => { e.target.style.opacity = '0'; }}
                    style={{ maxHeight: 250, maxWidth: 240, objectFit: 'contain', borderRadius: 14, filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.12))' }}
                  />
                  <div style={{ position: 'absolute', bottom: '0.6rem', left: '50%', transform: 'translateX(-50%)', background: 'white', color: 'var(--brand)', border: '1px solid var(--brand-light)', borderRadius: '9999px', padding: '0.2rem 0.75rem', fontSize: '0.73rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {p.capacity}
                  </div>
                </div>

                {/* Body */}
                <div style={{ padding: '1.5rem' }}>
                  <div style={{ fontSize: '0.68rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.2rem' }}>{p.brand}</div>
                  <h3 style={{ fontWeight: 800, fontSize: '0.9375rem', color: 'var(--text-dark)', marginBottom: '0.6rem' }}>{p.name}</h3>
                  <p className="text-justify" style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', lineHeight: 1.65, marginBottom: '1rem' }}>{p.description}</p>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', marginBottom: '1.1rem' }}>
                    {p.highlights.map(h => (
                      <div key={h} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8125rem', color: 'var(--text-body)' }}>
                        <span style={{ color: '#16a34a', fontWeight: 700, fontSize: '0.75rem' }}>&#x2713;</span>
                        {h}
                      </div>
                    ))}
                  </div>

                  {/* Price */}
                  <div style={{ borderTop: '1px solid var(--border-light)', paddingTop: '1rem', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.4rem' }}>
                      <span style={{ fontSize: '1.85rem', fontWeight: 900, color: 'var(--brand)' }}>₹{p.price}</span>
                      <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>per unit</span>
                    </div>
                    {p.deposit && (
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.2rem' }}>
                        + ₹{p.deposit} refundable deposit
                      </div>
                    )}
                  </div>

                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Link to={'/products/' + p.slug} className="btn-outline" style={{ flex: 1, justifyContent: 'center', padding: '0.55rem', fontSize: '0.84rem', borderRadius: '8px' }}>
                      Details
                    </Link>
                    <Link to="/contact" className="btn-brand" style={{ flex: 1, justifyContent: 'center', padding: '0.55rem', fontSize: '0.84rem', borderRadius: '8px', border: 'none' }}>
                      Order
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Notes */}
      <section className="section" style={{ background: 'white' }}>
        <div className="page-container">
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <span className="section-badge">Good to Know</span>
            <h2 className="section-title">Pricing &amp; Policies</h2>
          </div>
          <div className="grid grid-2" style={{ gap: '1.5rem' }}>
            <div className="pub-card" style={{ padding: '1.75rem', display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>
              <div style={{ width: 50, height: 50, borderRadius: '12px', background: '#FDE8E8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontWeight: 800, fontSize: '1.1rem', color: '#C8171A' }}>20L</div>
              <div>
                <h4 style={{ fontWeight: 800, color: 'var(--text-dark)', marginBottom: '0.5rem' }}>About Jar Deposits</h4>
                <p className="text-justify" style={{ color: 'var(--text-muted)', fontSize: '0.875rem', lineHeight: 1.75 }}>
                  For the 20L jar, a one-time refundable deposit of &#x20B9;150 is charged for the food-grade jar.
                  This deposit is fully refunded when you return the jar. Each refill is only &#x20B9;60.
                </p>
              </div>
            </div>
            <div className="pub-card" style={{ padding: '1.75rem', display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>
              <div style={{ width: 50, height: 50, borderRadius: '12px', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontWeight: 800, fontSize: '1.1rem', color: '#16a34a' }}>Bulk</div>
              <div>
                <h4 style={{ fontWeight: 800, color: 'var(--text-dark)', marginBottom: '0.5rem' }}>Bulk &amp; Monthly Orders</h4>
                <p className="text-justify" style={{ color: 'var(--text-muted)', fontSize: '0.875rem', lineHeight: 1.75 }}>
                  Order regularly? Ask about our monthly subscription plans and bulk discounts for businesses and large households. Contact us for custom pricing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="section" style={{ background: 'var(--brand-xlight)' }}>
        <div className="page-container">
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <span className="section-badge">Quick Compare</span>
            <h2 className="section-title">Product Comparison</h2>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: 'white', borderRadius: '14px', overflow: 'hidden', border: '1px solid var(--border-light)', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ background: 'var(--brand)', color: 'white' }}>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'left', fontWeight: 700 }}>Product</th>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'center', fontWeight: 700 }}>Capacity</th>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'center', fontWeight: 700 }}>Price</th>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'center', fontWeight: 700 }}>Deposit</th>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'center', fontWeight: 700 }}>Best For</th>
                  <th style={{ padding: '1rem 1.25rem', textAlign: 'center', fontWeight: 700 }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { slug: '20l-jar', name: 'Vijaya Varshi 20L Jar', cap: '20 Litres', price: '₹60', dep: '₹150 (refundable)', best: 'Families & Offices' },
                  { slug: '1l-bottle', name: 'Vijaya Varshi 1L Bottle', cap: '1 Litre', price: '₹20', dep: 'None', best: 'Home & Office Desk' },
                  { slug: '500ml-bottle', name: 'Vijaya 500ml Bottle', cap: '500 ml', price: '₹10', dep: 'None', best: 'School & Travel' },
                  { slug: '250ml-bottle', name: 'Vijaya 250ml Bottle', cap: '250 ml', price: '₹6', dep: 'None', best: 'Events & Functions' },
                ].map((row, i) => (
                  <tr key={row.slug} style={{ background: i % 2 === 0 ? 'white' : '#f8fafc' }}>
                    <td style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border-light)' }}>
                      <span style={{ fontWeight: 600, color: 'var(--text-dark)' }}>{row.name}</span>
                    </td>
                    <td style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid var(--border-light)', color: 'var(--text-body)' }}>{row.cap}</td>
                    <td style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid var(--border-light)', fontWeight: 800, color: 'var(--brand)' }}>{row.price}</td>
                    <td style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid var(--border-light)', color: 'var(--text-muted)', fontSize: '0.85rem' }}>{row.dep}</td>
                    <td style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid var(--border-light)', color: 'var(--text-body)', fontSize: '0.875rem' }}>{row.best}</td>
                    <td style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid var(--border-light)' }}>
                      <Link to={'/products/' + row.slug} className="btn-outline" style={{ padding: '0.4rem 1rem', fontSize: '0.8125rem', borderRadius: '7px' }}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: 'var(--brand)', padding: '3.5rem 1.5rem', textAlign: 'center' }}>
        <div className="page-container">
          <h2 style={{ fontSize: '1.85rem', fontWeight: 800, color: 'white', marginBottom: '0.75rem' }}>Ready to Order?</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem' }}>
            Get in touch and we will arrange your first delivery at the earliest.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" style={{ background: 'white', color: 'var(--brand)', padding: '0.85rem 2.25rem', borderRadius: '10px', fontWeight: 700, fontSize: '1.0625rem', textDecoration: 'none' }}>
              Contact Us &#8594;
            </Link>
            <a href="tel:8374422411" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '2px solid rgba(255,255,255,0.45)', padding: '0.85rem 2.25rem', borderRadius: '10px', fontWeight: 700, fontSize: '1.0625rem', textDecoration: 'none' }}>
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
